<template>
	<div class="homepage-test">
		<!-- definePageMeta -->
		<Head>
			<Title>{{ pageMetaObject?.title ?? `${$t('common.home_page')} | CarFree` }}</Title>
			<Meta name="description" :content="pageMetaObject?.description ?? ''" />
			<Meta v-if="config.public.environment === 'production-to-change' && robotsCalculated" name="robots" :content="robotsCalculated ?? ''" />
			<Meta v-else name="robots" content="noindex, nofollow" />
			<Link rel="canonical" :href="pageMetaObject?.canonical && pageMetaObject?.canonical?.trim() ? pageMetaObject?.canonical : url.href" />
		</Head>

		<GlobalHeader booker />
		<HomePageHero />
		<PromoBanners disableAos />
		<LazyVisibleGlobalNumberOneSection hydrate-on-visible />
		<LazyVisibleTestimonials hydrate-on-visible />
		<LazyVisibleHomePageChooseCar hydrate-on-visible />
		<LazyVisibleGlobalSEOSection hydrate-on-visible :pageType="ECMSType.SUBPAGE" :page="ECMSPage.HOME" />
		<LazyVisibleHomePageContentSection hydrate-on-visible />
		<LazyVisibleGlobalDepartmentsSection
			hydrate-on-visible
			:title="isMobile_md ? $t('pages.index.branch_in_every_city') : $t('pages.index.branches_of_our_company')" />
		<LazyVisibleGlobalApplicationBanner hydrate-on-visible />
		<LazyVisibleGlobalNewsSection v-if="locale === 'pl'" hydrate-on-visible />
		<!-- <GlobalSEOSectionAccordion :pageType="ECMSType.SUBPAGE" :page="ECMSPage.HOME" /> -->
		<LazyVisibleGlobalFooter hydrate-on-visible />
	</div>
</template>

<script setup lang="ts">
// const navRef = ref<HTMLElement | null>(null)

// const navHeight = computed(() => {
// 	return `${navRef.value?.clientHeight}px`
// })
import { ECMSType, ECMSPage } from '@/modules/adminModule/constants/pagesCMSconstants'
const config = useNuxtApp().$config
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
// const bookingStore = useBookingStore()
const { locale } = useI18n()
const url = useRequestURL()
// const locationsStore = useLocationsStore()

// onMounted(() => {
// bookingStore.fetchBooking()
// })

const loginByCode = async () => {
	try {
		const code = route.query.code as string
		if (code) {
			await userStore.loginByToken(code)
		}
	} catch (error) {
		console.log(error)
	} finally {
		const code = route.query?.code as string
		if (code) {
			router.push({ query: {} })
		}
	}
}
const pageSectionsStore = usePageSectionsStore()

const pageSections = computed(() => pageSectionsStore.getPageSections)
const pageMetaObject = computed(() => pageSectionsStore.pageMetaObject)
// const pageSections = ref<IHomePageSectionModel[]>()
// const pageMetaObject = ref<{ [key: string]: string } | undefined>()

// const getHomePageSections = async () => {
// 	try {
// 		const response = await ApiService.fetchPageSections(ECMSType.SUBPAGE, ECMSPage.HOME, locale.value)
// 		pageSections.value = response.data
// 		pageMetaObject.value = response.data
// 			?.find((section) => section.name === EPageSectionType.META)
// 			?.translations.find((translation) => translation.language === locale.value)?.content[0]

// 		return response
// 	} catch (error) {
// 		console.log(error)
// 	}
// }

const googleRatingsStore = useGoogleRatingsStore()
const locationsStore = useLocationsStore()

await Promise.all([
	loginByCode(),
	pageSectionsStore.fetchPageSections(),
	locationsStore.fetchLocationCities(true),
	locationsStore.fetchLocations(true),
	googleRatingsStore.fetchGoogleRating(),
])

provide('pageSections', pageSections)
const cookie = useCookie('cf-car')
cookie.value = null
const bookerTarget = ref<HTMLElement | null>(null)
provide('bookerTarget', bookerTarget)

const { isMobile_md } = useWindowWidth()

const isNavBookerVisible = ref()
provide('isNavBookerVisible', isNavBookerVisible)

// const resetData = () => {
// 	useReservationStore().deleteLocalStorage('cf_booker')
// 	location.reload()
// }

const robotsCalculated = computed(() => {
	if (!pageMetaObject.value?.robots || pageMetaObject.value?.robots?.length === 0) return undefined
	return pageMetaObject.value?.robots.join(', ')
})

const sendAnalyticsData = () => {
	const gtmService = useGTMService()
	if (!gtmService) return
	gtmService.pageViewed({ page_type: 'homepage' })
}

if (process.client) sendAnalyticsData()

const carsStore = useCarsStore()

// fetch data for cars page to load faster
onMounted(() => {
	Promise.all([
		carsStore.fetchAllCars(),
		carsStore.fetchAllFilters(),
		carsStore.fetchAllSegments(),
		carsStore.fetchAllGroups(),
		locationsStore.fetchLocations(),
	])
})

definePageMeta(pageMeta.HOME.HOME)
</script>

<style lang="scss">
@import './index';
</style>
